import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Progress } from 'reactstrap'
import Skeleton from '../UI/Skeleton'

class CourseMiniCard extends React.Component {
    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="course">
                            <Skeleton className="title md-font-size" width={'70%'} />
                            <Skeleton className="completed sm-font-size" width={'40%'} />
                            <Skeleton className="course-bar" />
                        </div>
                        :
                        <div className="course">
                            <div className="title md-font-size">{this.props.title}</div>
                            <div className="completed sm-font-size">{this.props.status.completed} {t('study-out')} {this.props.status.from} {t('study-lessons-passed')}</div>
                            <Progress className="course-bar" value={this.props.status.percent} color="success" />
                        </div>
                }
            </React.Fragment>
        )
    }
}

CourseMiniCard.propTypes = {
    t: PropTypes.func,
    status: PropTypes.object,
    title: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(CourseMiniCard)



// WEBPACK FOOTER //
// ./src/components/Study/CourseMiniCard.jsx